<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
        isDelete: true
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>

import GridView from "../../../components/common/GridView";
export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('Setuprankmapset.rankmapsetlisting'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('Setuprankmapset.rankmapset'), value: "rankmapset", width: "200px" },
        { text: this.$t('Setuprankmapset.rankmapsetdesc'), value: "description", width: "200px" },
        { text: this.$t('columns.remark'), value: "remark", width: "200px" },
        { text: this.$t('columns.disable'), value: "disabletext", width: "200px" },
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
       search: this.$route.params.search,
    };
  },

  methods: {
    getRankMapSetHandler() {
      const vm = this;
      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/rankmapset/all"})
        .then(function (res) {
            vm.dataItems = res.data.rec.map(item => {
              return {
                ...item,
                disabletext: item.disable === 1 ? 'Yes' : 'No'
              };
            });
          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "rankmapsetedit", params: { id: item.id, search: item.search  } });
    },

    deleteItemHandler(item) {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
          return false;
      }

      if (confirm(this.$t('pmrankmapset.deleterankmapset', { code: item.rankmapset }))) {
        this.$store.dispatch('delete', {url: "/rankmapset/" + item.id})
          .then(function () {
            vm.getRankMapSetHandler();
          })
          .catch(function (err) {
            vm.errMsg = err;
          });
      }
    },

    newRecordHandler() {
      this.$router.push({ name: "rankmapsetnew" });
    },
  },

  mounted() {
    this.getRankMapSetHandler();
  },
};
</script>